import { useMemo } from 'react';

export default (
  useResource,
  mapKey,
  dataKey = 'data',
  loadingKey = 'loading'
) => {
  const { [dataKey]: data, [loadingKey]: loading } = useResource();
  return useMemo(() => {
    if (loading) {
      return { data, loading };
    }
    return data
      .filter((x) => x[mapKey])
      .reduce(
        (prev, entity) => {
          prev.data[entity[mapKey]] = entity;
          return prev;
        },
        { data: {}, loading }
      );
  }, [data, loading, mapKey]);
};
